interface GetNostoResponseParams {
  browserWindow: any;
  cartItems: any[];
  globals: any;
  nostoPlacementId: string;
}

export const extractNostoProductIds = (payload: any): number[] => {
  const ids = new Set<number>();

  const walk = (value: any) => {
    if (!value) return;

    if (Array.isArray(value)) {
      value.forEach(walk);
      return;
    }

    if (typeof value === "object") {
      Object.entries(value).forEach(([key, nestedValue]) => {
        const normalizedKey = key.toLowerCase();
        if (normalizedKey === "product_id" || normalizedKey === "productid") {
          const numeric = Number(nestedValue);
          if (!Number.isNaN(numeric) && numeric > 0) {
            ids.add(numeric);
          }
        }
        walk(nestedValue);
      });
    }
  };

  walk(payload);
  return Array.from(ids);
};

export const getNostoResponse = async ({
  browserWindow,
  cartItems,
  globals,
  nostoPlacementId,
}: GetNostoResponseParams) => {
  const nostoResponse = await new Promise<any>((resolve) => {
    browserWindow.nostojs(async (api: any) => {
      try {
        const requestBuilder = typeof api?.defaultSession === "function" ? api.defaultSession() : api;

        const cartPayload = {
          items: (cartItems || []).map((item: any) => ({
            product_id: String(item.product_id),
            sku_id: String(item.variant_id),
            name: item.title,
            unit_price: item.price / 100,
            price_currency_code: globals?.currency || browserWindow.Shopify?.currency?.active,
            quantity: item.quantity,
          })),
        };

        const response = await requestBuilder
          .setResponseMode("JSON_ORIGINAL")
          .setCart(cartPayload)
          .viewCart()
          .setPlacements([nostoPlacementId])
          .load({ trackEvents: false });
        resolve(response);
      } catch (error) {
        console.error("Error loading Nosto recommendations: ", error);
        resolve(null);
      }
    });
  });

  return nostoResponse;
};
